import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isMessageSent, setIsMessageSent] = useState(false);
  const [validationErrors, setValidationErrors] = useState({ name: '', email: '', message: '' });

  const handleNameChange = (event) => {
    setName(event.target.value);
    setValidationErrors({ ...validationErrors, name: event.target.value ? '' : 'Name cannot be empty' });
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setValidationErrors({ ...validationErrors, email: event.target.value ? '' : 'Email cannot be empty' });
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
    setValidationErrors({ ...validationErrors, message: event.target.value ? '' : 'Message cannot be empty' });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!name || !email || !message) {
      setValidationErrors({
        name: !name ? 'Name cannot be empty' : '',
        email: !email ? 'Email cannot be empty' : '',
        message: !message ? 'Message cannot be empty' : '',
      });
      return;
    }

    emailjs
      .sendForm('service_235w0zq', 'template_0opiuhe', event.target, 'QDBM3utPhWhWcz2aE')
      .then(() => {
        console.log('Message sent successfully!');
        console.log(email);
        console.log(name);
        setIsMessageSent(true);
        setName('');
        setEmail('');
        setMessage('');
      })
      .catch((error) => {
        console.error('Error sending message:', error);
      });
  };

  return (
    <div className="w-80vw mx-auto">
      <h1 className="bg-[#000b1a] py-12 text-4xl font-bold text-white md:py-12 md:text-6xl lg:py-12 lg:text-6xl">
        CONTACT US
      </h1>
      <div className="contact-section-1 relative flex flex-col items-center px-6 py-4 md:px-80 lg:px-96">
        <div className="glass-effect w-full rounded-xl bg-white p-8">
          <form className="flex flex-col items-center py-14" onSubmit={handleSubmit}>
            <div className="mb-4 w-full">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={name}
                onChange={handleNameChange}
                onBlur={handleNameChange}
                className="glass-input my-2 h-12 w-full rounded-md border border-blue-500 p-2"
              />
              <span className="mt-1 ml-2 block text-sm text-red-500">{validationErrors.name}</span>
            </div>
            <div className="mb-4 w-full">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={handleEmailChange}
                onBlur={handleEmailChange}
                className="glass-input my-2 h-12 w-full rounded-md border border-blue-500 p-2"
              />
              <span className="mt-1 ml-2 block text-sm text-red-500">{validationErrors.email}</span>
            </div>
            <div className="mb-8 w-full">
              <textarea
                name="message"
                placeholder="Message"
                value={message}
                onChange={handleMessageChange}
                onBlur={handleMessageChange}
                className="glass-input my-2 h-24 w-full rounded-md border border-blue-500 p-2"
              ></textarea>
              <span className="mt-1 ml-2 block text-sm text-red-500">{validationErrors.message}</span>
            </div>
            <button
              type="submit"
              className="glass-button w-full rounded-lg border border-[#46C6ED] bg-[#000b1a] py-2 px-4 font-semibold text-[#46C6ED]"
            >
              Submit
            </button>
            {isMessageSent && <p>Message sent successfully!</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
